import { connect, MapStateToProps } from 'react-redux';
import { Props } from './App';
import { AppState } from '../../../types/store';
import { appMounted } from '../../../actions/app';
import { getPickerStep } from '../../../redux/packagePicker/selectors';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';

export type StateProps = Pick<Props, 'environment' | 'pickerStep'>;
export type DispatchProps = Pick<Props, 'appMounted'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  environment: getEnv(state).type,
  pickerStep: getPickerStep(state),
});

const mapDispatchToProps: DispatchProps = {
  appMounted,
};

export default connect(mapStateToProps, mapDispatchToProps);
